module.exports = __webpack_public_path__ + "media/promo/velle/images/logo-2872257f6db0636901de30ebbb8b9308.png";